var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "收货地址",
        width: "600px",
        visible: _vm.visible,
        "close-on-click-modal": false
      },
      on: {
        close: function($event) {
          return _vm.$emit("update:visible", false)
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: {
            "label-suffix": "：",
            size: "medium",
            model: _vm.form,
            rules: _vm.rules,
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "收货人", prop: "name" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入收货人" },
                model: {
                  value: _vm.form.name,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "name", $$v)
                  },
                  expression: "form.name"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "联系方式", prop: "tel" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入联系方式", maxlength: "11" },
                model: {
                  value: _vm.tel,
                  callback: function($$v) {
                    _vm.tel = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "tel"
                }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "收货地址", prop: "areaId" } },
            [
              _c("el-cascader", {
                staticStyle: { width: "100%" },
                attrs: {
                  placeholder: "请选择收货地址",
                  value: _vm.areaValue,
                  props: _vm.area
                },
                on: { change: _vm.areaChange }
              })
            ],
            1
          ),
          _c(
            "el-form-item",
            { attrs: { label: "详细地址", prop: "addr" } },
            [
              _c("el-input", {
                attrs: { placeholder: "请输入详细收货地址", type: "textarea" },
                model: {
                  value: _vm.form.addr,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "addr", $$v)
                  },
                  expression: "form.addr"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "template",
        { slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { size: "medium" },
              on: {
                click: function($event) {
                  return _vm.$emit("update:visible", false)
                }
              }
            },
            [_vm._v("取 消")]
          ),
          _c(
            "el-button",
            {
              attrs: { size: "medium", type: "primary" },
              on: { click: _vm.submitForm }
            },
            [_vm._v("确 定")]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }